import Reflux from 'reflux';
import api from '../api/header';

var actions = Reflux.createActions({
  search:             {asyncResult: true},
  clearSearch:        {},
  logout:             {asyncResult: true},

  // TODO, remove this in production
  switchMode: {},

  // call this after calculating the max categories in the more panel
  toggleMaxVisibleCategories: {},

  toggleCategory: {},
  toggleMidPanel: {},
  toggleTopPanel: {},
  toggleSlidingPanel: {}
});

var timeout = null;
actions.search.listen(function (url, searchTerm) {
  clearTimeout(timeout);

  if (searchTerm) {
    var debounceRate = 50;
    if (searchTerm.length < 2) {
      // For the first keystroke there is no need for a timeout
      // we want a result to show up asap
      debounceRate = 0;
    }

    timeout = setTimeout(function () {
      // call the server
      api.search(url, searchTerm)
         .then(this.completed)
         .catch(this.failed);
    }.bind(this), debounceRate);
  }
});

actions.logout.listen(function (url) {
  api.logout(url)
    .done(function () {
      if (window.location.pathname === '/checkout/confirmation.php') {
        window.location.href = '/';
      }
      else if (/^\/myAccount\//.test(window.location.pathname)) {
        window.location.href = '/myAccount/loginRegister.php#login';
      }
      else {
        window.location.reload();
      }
    });
});

export default  actions;



// WEBPACK FOOTER //
// ./frontend/react/actions/header.js